/* eslint-disable import/prefer-default-export */

export const LABELS = {
  LOGIN: 'Login',
  YOU: 'You',
};
